export default __webpack_public_path__ + "static/media/github.2c6075f7.png";